import React from "react";
import { Redirect } from "react-router-dom";

import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Dashboard from "../pages/Dashboard/index";

import ProfileRoles from "../pages/Profile/Role/Roles";
import Users from "../pages/Profile/Users/Users";
// import ProfileAddRoles from "../pages/Profile/Role/AddRoles";
// import ProfileEditRoles from "../pages/Profile/Role/EditRoles";

import Salons from "pages/Salon/Salons";
import Categories from "pages/Category/Categories";
import AddCategory from "pages/Category/AddCategory";
import EditCategory from "pages/Category/EditCategory";
import Services from "pages/Service/Services";

import SubServices from "pages/SubService/SubServices";
import Permissions from "pages/Profile/Permission/Permissions";
import SalonsEdit from "pages/Salon/SalonsEdit";
import PageContent from "pages/Setting/PageContent";
import EditPageContent from "pages/Setting/EditPageContent";
import AllSalon from "pages/Salon/AllSalon";
import ViewSalon from "pages/Salon/ViewSalon";
import CouponCodes from "pages/CouponCode/CouponCodes";
import AddEditCouponCode from "pages/CouponCode/AddEditCouponCode";
import PriceRangeSlabList from "pages/PriceRangeSlab/PriceRangeSlabList";
import AddEditPriceRangeSlab from "pages/PriceRangeSlab/AddEditPriceRangeSlab";
import ServiceCategoryRequests from "pages/serviceCategoryRequest/ServiceCategoryRequests";

import EditServiceCategoryRequests from "pages/serviceCategoryRequest/EditServiceCategoryRequests";

import OfficialHolidaysList from "pages/OfficialHoliday/OfficialHolidaysList";
import AddEditOfficialHoliday from "pages/OfficialHoliday/AddEditOfficialHoliday";
import VendorAccountings from "pages/VendorAccounting/VendorAccountings";
import AddEditVendorAccounting from "pages/VendorAccounting/AddEditVendorAccounting";
import AllBooking from "pages/Booking/AllBooking";
// import EditBookingPage from "pages/Bookings/EditBookingPage";
import ViewBooking from "pages/Booking/ViewBooking";
import GeneralSettings from "pages/GeneralSetting/GeneralSettings";
import EditGeneralSetting from "pages/GeneralSetting/EditGeneralSetting";
import AllUsers from "pages/Users/AllUsers";
import ViewUser from "pages/Users/ViewUser";
import AllAdminUsers from "pages/AdminUser/AllAdminUsers";
import ViewAdminUser from "pages/AdminUser/ViewAdminUser";


import ContactUs from "pages/Contact/ContactList";
import ViewContactList from "pages/Contact/ViewContactList";


const authProtectedRoutes = [
    { path: "/dashboard", component: Dashboard },
    { path: "/roles", component: ProfileRoles },
    { path: "/users/:role_id", component: Users },
    { path: "/permissions/:role_id", component: Permissions },
    { path: "/approved-salons", component: Salons },
    { path: "/rejected-salons", component: Salons },
    { path: "/new-request-salons", component: Salons },
    { path: "/ammendment-required-salons", component: Salons },
    { path: "/edit-salon/:salon_id", component: SalonsEdit },
    { path: "/view-salon/:salon_id", component: ViewSalon },
    { path: "/categories", component: Categories },
    { path: "/add-category", component: AddCategory },
    { path: "/edit-category/:id", component: EditCategory },
    { path: "/services", component: Services },
    { path: "/sub-services", component: SubServices },
    { path: "/page-content", component: PageContent },
    { path: "/edit-page-content/:id", component: EditPageContent },
    { path: "/all-salons", component: AllSalon },
    { path: "/coupon-codes", component: CouponCodes },
    { path: "/add-coupon-code", component: AddEditCouponCode },
    { path: "/edit-coupon-code/:id", component: AddEditCouponCode },
    { path: "/price-range-slab", component: PriceRangeSlabList },
    { path: "/add-price-range-slab", component: AddEditPriceRangeSlab },
    { path: "/edit-price-range-slab/:id", component: AddEditPriceRangeSlab },
    { path: "/service-category-requests", component: ServiceCategoryRequests },
    { path: "/edit-request-category/:id", component: EditServiceCategoryRequests },

    { path: "/official-holidays", component: OfficialHolidaysList },
    { path: "/add-official-holiday", component: AddEditOfficialHoliday },
    { path: "/edit-official-holiday/:id", component: AddEditOfficialHoliday },
    { path: "/vendor-accountings", component: VendorAccountings },
    { path: "/add-vendor-accounting", component: AddEditVendorAccounting },
    { path: "/edit-vendor-accounting/:id", component: AddEditVendorAccounting },

    { path: "/contact-us", component: ContactUs },
    { path: "/view-contact/:id", component: ViewContactList },

    { path: "/general-setting", component: GeneralSettings },
    { path: "/edit-general-setting/:id", component: EditGeneralSetting },
  { path: "/dashboard", component: Dashboard },
  { path: "/roles", component: ProfileRoles },
  { path: "/users/:role_id", component: Users },
  { path: "/permissions/:role_id", component: Permissions },
  { path: "/salons", component: Salons },
  { path: "/edit-salon/:salon_id", component: SalonsEdit },
  { path: "/view-salon/:salon_id", component: ViewSalon },
  { path: "/categories", component: Categories },
  { path: "/add-category", component: AddCategory },
  { path: "/edit-category/:id", component: EditCategory },
  { path: "/services", component: Services },
  { path: "/sub-services", component: SubServices },
  { path: "/page-content", component: PageContent },
  { path: "/edit-page-content/:id", component: EditPageContent },
  { path: "/all-salons", component: AllSalon },
  { path: "/coupon-codes", component: CouponCodes },
  { path: "/add-coupon-code", component: AddEditCouponCode },
  { path: "/edit-coupon-code/:id", component: AddEditCouponCode },
  { path: "/price-range-slab", component: PriceRangeSlabList },
  { path: "/add-price-range-slab", component: AddEditPriceRangeSlab },
  { path: "/edit-price-range-slab/:id", component: AddEditPriceRangeSlab },
  { path: "/service-category-requests", component: ServiceCategoryRequests },
  { path: "/official-holidays", component: OfficialHolidaysList },
  { path: "/add-official-holiday", component: AddEditOfficialHoliday },
  { path: "/edit-official-holiday/:id", component: AddEditOfficialHoliday },
  { path: "/vendor-accountings", component: VendorAccountings },
  { path: "/add-vendor-accounting", component: AddEditVendorAccounting },
  { path: "/edit-vendor-accounting/:id", component: AddEditVendorAccounting },

  { path: "/general-setting", component: GeneralSettings },
  { path: "/edit-general-setting/:id", component: EditGeneralSetting },
  { path: "/bookings", component: AllBooking },
  // { path: "/edit-booking/:id", component: EditBookingPage },
  { path: "/view-booking/:id", component: ViewBooking },
  { path: "/all-users", component: AllUsers },
  { path: "/view-user/:id", component: ViewUser },
  { path: "/view-admin-user/:id", component: ViewAdminUser },
  { path: "/admin-users", component: AllAdminUsers },
];

const publicRoutes = [
  { path: "/", component: Login },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/logout", component: Logout },
  { path: "/forgot-password", component: ForgetPwd },
];

export { authProtectedRoutes, publicRoutes };
